/**
 * oldMeterCompatibleManagement 模块英文映射
 * 中文原文做 key，value 为英文译文；由 src/i18n/index.js 自动合并
 */
export default {
  '剩余金额': 'Remaining Balance',
  '用户卡号：': 'User card no.: ',
  '表类型': 'Meter Type',
  '下载插件': 'Download Plugin',
  '临时充值卡': 'Temporary Recharge Card',
  '买水次数': 'Water Purchase Count',
  '价格名称': 'Price Name',
  '信息': 'Notice',
  '元': 'CNY',
  '元/m³': 'CNY/m³',
  '充值次数': 'Recharge Count',
  '共{total}条': 'Total {total} records',
  '关闭': 'Close',
  '其他': 'Other',
  '写卡': 'Write Card',
  '写卡器连接错误，请确保插件正常运行后，刷新页面重试!': 'Card writer connection error. Make sure the plugin is running properly, then refresh the page and try again!',
  '写卡失败': 'Card write failed',
  '写卡成功': 'Card written successfully',
  '写卡操作': 'Card Writing',
  '写卡类型': 'Card Write Type',
  '分': 'min',
  '分钟': 'min',
  '创建人': 'Created By',
  '创建时间': 'Created At',
  '删除': 'Delete',
  '制卡': 'Card Issuing',
  '制卡操作': 'Card Issuing',
  '刷卡日期': 'Swipe Date',
  '刷卡日期：': 'Swipe date: ',
  '刷卡标识': 'Swipe Flag',
  '刷卡标识：': 'Swipe flag: ',
  '刷新': 'Refresh',
  '刷新当前页面?': 'Refresh this page?',
  '刷新当前页面重置当前页面，请确定是否进行刷新操作?': 'Refreshing will reset this page. Are you sure you want to refresh?',
  '剩余金额(元)': 'Remaining Balance (CNY)',
  '剩余金额：': 'Remaining balance: ',
  '功能描述': 'Function Description',
  '单价': 'Unit Price',
  '单价(元)': 'Unit Price (CNY)',
  '单价：': 'Unit price: ',
  '单次购买最大金额': 'Max Single Purchase Amount',
  '卡片价格(元)': 'Card Price (CNY)',
  '卡片价格有误，请输入正确的卡片价格': 'Invalid card price, please enter a valid card price',
  '卡类型': 'Card Type',
  '参数卡': 'Parameter Card',
  '取消': 'Cancel',
  '取消选择': 'Deselect',
  '合计单价': 'Total Unit Price',
  '否': 'No',
  '周': 'Week',
  '备注': 'Remark',
  '天': 'Day',
  '安装位置': 'Installation Location',
  '导出': 'Export',
  '导出文件': 'Export File',
  '展开': 'Expand',
  '已制卡': 'Card Issued',
  '已刷卡': 'Swiped',
  '已选择 {count} 项': '{count} items selected',
  '年': 'Year',
  '开始时间': 'Start Time',
  '当前余额': 'Current Balance',
  '当前表结算累计流量': 'Current Settled Cumulative Flow',
  '当前选择：': 'Currently selected:',
  '手机号码': 'Mobile Phone',
  '批量操作': 'Batch Operations',
  '抄表员': 'Meter Reader',
  '抄表日期': 'Meter Reading Date',
  '抄表时间': 'Meter Reading Time',
  '折叠': 'Collapse',
  '报警金额': 'Alarm Amount',
  '按季度': 'Quarterly',
  '按年': 'Yearly',
  '按月': 'Monthly',
  '换表卡': 'Meter Replacement Card',
  '描述': 'Description',
  '提示': 'Notice',
  '插件连接成功': 'Plugin connected',
  '操作': 'Action',
  '收起': 'Collapse',
  '故障': 'Fault',
  '故障清除卡': 'Fault Clear Card',
  '新增': 'Add',
  '无': 'None',
  '日': 'Day',
  '时': 'h',
  '是': 'Yes',
  '更多': 'More',
  '更新用户卡': 'Update User Card',
  '最大囤积金额': 'Max Stockpile Amount',
  '最大透支金额': 'Max Overdraft Amount',
  '月': 'Month',
  '有': 'Yes',
  '未制卡': 'Card Not Issued',
  '未刷卡': 'Not Swiped',
  '未知': 'Unknown',
  '查询': 'Query',
  '查询结束时间': 'End time',
  '查询起始时间': 'Start time',
  '标准卡': 'Standard Card',
  '校时卡': 'Time Sync Card',
  '次': 'times',
  '正常': 'Normal',
  '水编号卡': 'Water No. Card',
  '水表校对卡': 'Meter Verification Card',
  '水表编号卡': 'Water Meter No. Card',
  '水表至数': 'Meter Reading Digits',
  '测试卡': 'Test Card',
  '清空': 'Clear',
  '清零卡': 'Reset Card',
  '照片记录': 'Photo Record',
  '状态': 'Status',
  '用户余额': 'Customer Balance',
  '用户信息': 'Customer Info',
  '用户制卡时间': 'Card Issuing Time',
  '用户卡': 'User Card',
  '用户卡充值': 'Customer Card Recharge',
  '用户卡号': 'User Card No.',
  '用户地址': 'Customer Address',
  '用户姓名': 'Customer Name',
  '用户所在区域名称': 'Customer Area Name',
  '用户是否制卡': 'Card Issued',
  '用户编号': 'Customer No.',
  '确定': 'OK',
  '确定删除吗?': 'Are you sure you want to delete?',
  '确定要制卡吗?': 'Are you sure you want to issue the card?',
  '确定要更新用户卡吗?': 'Are you sure you want to update the user card?',
  '秒': 's',
  '第一阶段用水价格': 'Tier-1 Water Price',
  '系统中没有该用户信息': 'No such customer info in the system',
  '累计流量：': 'Cumulative flow: ',
  '累计用量': 'Cumulative Usage',
  '累计用量：': 'Cumulative usage: ',
  '累计量': 'Cumulative Volume',
  '结算累计流量(m³)': 'Settled Cumulative Flow (m³)',
  '编辑': 'Edit',
  '表IMEI号': 'Meter IMEI',
  '表编号': 'Meter No.',
  '计费类型': 'Billing Type',
  '该用户不允许缴费！': 'This customer is not allowed to pay!',
  '详情': 'Details',
  '请前往缴费大厅充值': 'Please go to the payment hall to recharge',
  '请输入买水次数': 'Enter water purchase count',
  '请输入单价': 'Enter unit price',
  '请输入单次购买最大金额': 'Enter max single purchase amount',
  '请输入卡片价格': 'Enter card price',
  '请输入抄表员': 'Enter meter reader',
  '请输入报警金额': 'Enter alarm amount',
  '请输入最大囤积金额': 'Enter max stockpile amount',
  '请输入最大透支金额': 'Enter max overdraft amount',
  '请输入正确的单价': 'Enter a valid unit price',
  '请输入正确的用户余额': 'Enter a valid customer balance',
  '请输入正确的用户卡号': 'Enter a valid user card no.',
  '请输入正确的累积量': 'Enter a valid cumulative volume',
  '请输入正确的购买次数': 'Enter a valid purchase count',
  '请输入用户余额': 'Enter customer balance',
  '请输入用户卡号': 'Enter user card no.',
  '请输入第一阶段用水价格': 'Enter tier-1 water price',
  '请输入累积量': 'Enter cumulative volume',
  '请输入预存金额': 'Enter prepaid amount',
  '读卡': 'Read Card',
  '读卡信息': 'Card Read Info',
  '读卡操作': 'Card Reading',
  '读取参数': 'Read Parameters',
  '购买次数': 'Purchase Count',
  '购买次数：': 'Purchase count: ',
  '超级阀门卡': 'Super Valve Card',
  '退水卡': 'Water Refund Card',
  '重置': 'Reset',
  '阀门卡': 'Valve Card',
  '非本公司卡': 'Card not from this company',
  '预存金额': 'Prepaid Amount',
}
